export const UpdateFinancialValidation = (formData) => {
    const errors = {};

    if (!formData.snt_SalesNominalCode) {
        errors.snt_SalesNominalCode = 'This field is required';
    }

    if (!formData.snt_PurchaseNominalCode) {
        errors.snt_PurchaseNominalCode = 'This field is required';
    }

    if (!formData.dec_TaxCode || formData.dec_TaxCode === "0") {
        errors.dec_TaxCode = 'This field is required';
    }

    if (!formData.vc_CommodityCode) {
        errors.vc_CommodityCode = 'This field is required';
    }
    

    return errors;
};

